import get from 'lodash/fp/get';

export const isDeletable = get('deletable');

export const isEditable = get('editable');

export const isOwnerEditable = get('ownerEditable');

export const isReopenable = get('reopenable');
